var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"height":"100%","padding-bottom":"125px"},attrs:{"fluid":""}},[(_vm.showVehiclesAT)?_c('vehiclesAT'):_c('templatesAT')],1)}
var staticRenderFns = []

export { render, staticRenderFns }